import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { DownloadSection } from "@/components/DownloadSection";
import { SupportSection } from "@/components/SupportSection";
import { Footer } from "@/components/Footer";

export const Landing = () => (
  <div className="min-h-screen bg-pitch font-body text-white antialiased">
    <Header />
    <main>
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <DownloadSection />
      <SupportSection />
    </main>
    <Footer />
  </div>
);
